import React, {useCallback, useEffect, useState} from 'react';
import TitleMain from "../../components/Title/TitleMain";
import { useUser } from "../../contexts/UserContext";
import {Field, Form, Formik} from "formik";
import { sendMsg } from "../../services/ReportService";
import TextAreaCustom from "../../components/Field/TextAreaCustom";
import styles from '../../components/Form/Form.module.css';
import {useLocation} from "react-router-dom";
import {useModal} from "../../contexts/ModalContext";
import {getSeanceApi, getSeanceLocal} from "../../services/SeanceService";
import FieldCheckbox from "../../components/Field/FieldCheckbox";
import DateService from "../../services/DateService";

function ReportPage({ title }) {
    const { user } = useUser();
    const [data, setData] = useState('Un incident technique');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fromUrl = queryParams.get('from');
    const { showModal } = useModal();
    const handleSuccess = useCallback((message = "Succès") => {
        showModal('success', { children: message, timeout: 4000 });
    }, [showModal]);
    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 4000 });
    }, [showModal]);

    const handleSubmit = async (values, actions) => {
        try {
            const result = await sendMsg(values);
            if (result.success) {
                handleSuccess("Votre message a bien été envoyé");
            } else {
                handleError("Votre message n'a pas pu être enregistré : "+result.message);
            }
        } catch (error) {
            handleError("Votre message n'a pas pu être envoyé");
            alert(error.message);
        }
    };

    const parseUrl = (url) => {
        if (!url) return null;
        const segments = url.split('/');

        if (segments[0] === '') {
            segments.shift();
        }

        switch (segments[0]) {
            case 'seances':
                switch (segments[1]) {
                    case 'seance':
                        let id = segments[2];
                        const getSeance = process.env.REACT_APP_MODE === 'maquette' ? getSeanceLocal : getSeanceApi;
                        getSeance(+id)
                            .then((data) => {
                                if (data.seance) {
                                    const stringData = `${data.seance.titre} du ${DateService.formatDate(data.seance.startDate)} dispensé(e) par ${ data.seance.coach.prenom } ${ data.seance.coach.nom }`;
                                    setData(stringData);
                                }
                            })
                            .catch((err) => {
                                handleError("Une erreur est survenue lors de la récupération de la séance", err);
                            });

                        return { type: 'seance', id: segments[2] };
                    default:
                        return null;
                }
            case 'userstatus':
                setData('Mon compte');
                return { type: 'userstatus', id: segments[1] };
            case 'activites':
                setData('Une activité');
                return { type: 'activites', id: segments[1] };
            default:
                setData('Un incident technique');
                return null;
        }

    }

    useEffect(() => {
        parseUrl(decodeURIComponent(fromUrl));
    } , [location]);

    return (
        <div className="content">
            <TitleMain text={title} />

            <Formik
                initialValues={{ text: '', from: fromUrl || '', concern: true }}
                onSubmit={handleSubmit}>
                <Form>
                    <Field type="hidden" name="from" />

                    <h4 style={{ margin: "20px 0 4px 0", fontWeight: "500" }}>Mon problème concerne : </h4>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", margin: "0px 0 30px 0", fontSize: "0.95rem", color: "#333" }}>
                        {/*
                           <Field type={"checkbox"} name="concern" id="concern" />
                           <label htmlFor={"concern"} style={{ margin: "10px" }}><span style={{ fontWeight: "bold" }}>{data}</span> </label>
                        */}

                        <FieldCheckbox name={"concern"} label={data}/>
                    </div>

                    <TextAreaCustom label={"Votre message"} type={"text"} name={"text"} placeholder={"Entrez votre texte"}/>
                    <div style={{ margin: "16px 0" }}>
                        <p className={"text_info"}>Envoyé en tant que {user.prenom} {user.nom} {user.email}</p>
                    </div>
                    <button type="submit" className={`btn ${styles.btnSubmit}`}>ENVOYER</button>
                </Form>
            </Formik>
        </div>
    )
}

export default ReportPage;
